import React from 'react';
import { Box, Heading, Grid, Image, useColorModeValue, VStack } from '@chakra-ui/react';
import CustomCard from './components/CustomCard';
import cardInfo from './data/cardInfo';
import headPic from './assets/layered-peaks-haikei 1.png';
import { useNavigate } from 'react-router-dom';

const HomeView = () => {
  const cardBg = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('rcBrand.forest', 'white');
  const borderColor = useColorModeValue('customGray.700', 'white');
  const navigate = useNavigate();
  const pageBgColor = useColorModeValue("linear(to-r, rcBrand.forest, rcBrand.lime 80%)", "linear(to-b, black, rcBrand.forest 99%)");

  return (
    <VStack spacing={5} w="full" align="stretch">
      {/* Image Section */}
      <Box position="relative" w="100vw" h={{ base: '200px', md: '300px', lg: '350px' }} overflow="hidden">
        <Image
          src={headPic}
          alt="Ride Connection"
          w="100vw" // Full screen width
          h="90%" // Set height to full of the container
          // objectFit="cover" // Maintain aspect ratio but cover entire width
          objectPosition="bottom" // Show the bottom half of the image
        />
        {/* Title Over Image */}
        <Heading
          position="absolute"
          top="50%" // Center it vertically
          left="50%" // Center it horizontally
          transform="translate(-50%, -50%)" // Proper centering
          fontSize={{ base: '3xl', md: '5xl', lg: '6xl' }} // Large responsive font size
          fontWeight="bold"
          color="white"
          textShadow="2px 2px 10px rgba(0, 0, 0, 0.7)" // Subtle shadow for better contrast
          zIndex="1"
          letterSpacing="wider"
          px={4} // Add padding to the text
        >
          Ride Connection Applications
        </Heading>
      </Box>

      {/* Applications Grid */}
      <Box p={5} mx = "10%" >
        {/* Centered Subheading */}
        <Heading size="md" color={textColor} textAlign="center" mb={8}>
          Please Select the Appropriate Application for Your Department
        </Heading>
        
        {/* Responsive Grid with adjusted gaps */}
        <Grid 
          templateColumns="repeat(auto-fit, minmax(250px, 1fr))" 
          gap={{ base: 3, md: 6, lg: 8 }} // Adjust spacing based on screen size
          justifyContent="center" 
          justifyItems="center"
        >
          {cardInfo.map((card, index) => (
            <CustomCard
              key={index}
              appName={card.appName}
              description={card.description}
              onButtonClick={() => navigate(card.redirectTo)}
              bg={card.bgColor}
              icon={card.icon}
              textColor={"rcBrand.forest"}
            />
          ))}
        </Grid>
      </Box>
    </VStack>
  );
};

export default HomeView;
